import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ContractTypeId } from '@block-explorer/entities';

export const contractTypes = {
  [ContractTypeId.System]: 'System Contract',
  [ContractTypeId.Cep18]: 'CEP-18 Token',
  [ContractTypeId.CustomCep18]: 'CEP-18 Token',
  [ContractTypeId.CEP47Nft]: 'CEP-47 NFT',
  [ContractTypeId.CustomCEP47Nft]: 'CEP-47 NFT',
  [ContractTypeId.DeFi]: 'DeFi',
  [ContractTypeId.CEP78Nft]: 'CEP-78 NFT',
  [ContractTypeId.CustomCEP78Nft]: 'CEP-78 NFT',
  [ContractTypeId.NFTMarketplace]: 'NFT Marketplace',
  [ContractTypeId.CEP95Nft]: 'CEP-95 NFT',
};

export const ContractTypeName = ({
  contractTypeId,
}: {
  contractTypeId: number | null;
}) => {
  const { t } = useTranslation();

  return (
    <>
      {contractTypeId ? (
        <Trans t={t}>{contractTypes[contractTypeId]}</Trans>
      ) : null}
    </>
  );
};
